// extracted by mini-css-extract-plugin
export default {"page":"lyK9Ft","wixLogo":"hw6H3y","content":"PKq6NH","frame":"Bk1rTx","title":"FDRpcf"};